'use client';

import { type ReactNode, useLayoutEffect, useRef } from 'react';

const fitTitlesToLines = (root: HTMLElement) => {
  root.querySelectorAll<HTMLElement>('[data-shortcut-title]').forEach((title) => {
    title.style.width = '';
    const range = document.createRange();
    range.selectNodeContents(title);
    const widestLine = Math.max(0, ...Array.from(range.getClientRects(), (rect) => rect.width));
    if (widestLine > 0) {
      title.style.width = `${Math.ceil(widestLine)}px`;
    }
  });
};

export function ShortcutTitlesFit({ children }: { children: ReactNode }) {
  const rootRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const root = rootRef.current;
    if (!root) {
      return;
    }
    fitTitlesToLines(root);
    void document.fonts?.ready.then(() => fitTitlesToLines(root));
  }, []);

  return <div ref={rootRef}>{children}</div>;
}
